// 小程序host
var apiHost = 'https://api.xinyilin10.com/'
// var apiHost = 'http://127.0.0.1:5000/'
var ossHost = 'https://oss.xinyilin10.com/'
var loginurl = 'https://open.weixin.qq.com/connect/qrconnect?appid=wx56b397f8b0201322&redirect_uri=https://api.xinyilin10.com/wechat/login_from_website/&response_type=code&scope=snsapi_login&state=STATE'
// axios get请求
// 参数 : this指向 url 回调函数
function axiosGet(self, geturl, callback, catchback) {
  self.axios({
    method: 'get',
    headers: {
      'content-type': 'application/json', // 默认值
      'Authorization': 'Bearer ' + localStorage.getItem('access_token')
    },
    url: apiHost + geturl
  }).then(function (res) {
    callback(res.data)
  }).catch(function (res) {
    catchback(res)
  })
}

// axios post请求
// 参数: this指向 url post参数 成功回调 失败回调
function axiosPost(self, posturl, postData, callback, catchback) {
  self.axios({
    method: 'post',
    headers: {
      'content-type': 'application/json', // 默认值
      'Authorization': 'Bearer ' + localStorage.getItem('access_token')
    },
    data: postData,
    url: posturl.substr(0, 4) === 'http' ? posturl : apiHost + posturl
  }).then(function (res) {
    callback(res.data)
  }).catch((response) => {
    catchback(response)
  })
}

// axios delete请求
// 参数: this指向 url 成功回调 失败回调
function axiosDelete(self, delurl, callback, catchback) {
  self.axios({
    method: 'delete',
    headers: {
      'content-type': 'application/json', // 默认值
      'Authorization': 'Bearer ' + localStorage.getItem('access_token')
    },
    url: apiHost + delurl
  }).then(function (res) {
    callback(res.data)
  }).catch((response) => {
    catchback(response)
  })
}

// axios put请求
// 参数: this指向 url 成功回调 失败回调
function axiosPut(self, puturl, putData, callback, catchback) {
  self.axios({
    method: 'put',
    headers: {
      'content-type': 'application/json', // 默认值
      'Authorization': 'Bearer ' + localStorage.getItem('access_token')
    },
    data: putData,
    url: apiHost + puturl
  }).then(function (res) {
    callback(res.data)
  }).catch((response) => {
    catchback(response)
  })
}

// 时间转时间戳
function timeToStamp(time) {
  var date = new Date(time)
  var Stamp = Date.parse(date) / 1000
  return Stamp
}

// 获取当前时间字符串
function getTime() {
  new Date().toLocaleString('China', {hour12: false})
}

// 通用文件上传
function uploadfile(self, eleid, callback, failback) {
  var formData = new FormData()
  var files = []
  var file = $('#' + eleid)[0].files[0]
  files.push(file)
  if (files.length < 1) {
    formData.append('file', new Blob())
  } else {
    formData.append('file', file)
  }
  axiosPost(self, 'upload/', formData, function (res) {
    callback(res)
  }, function (res) {
    failback(res)
  })
}

export default {
  loginurl,
  apiHost,
  ossHost,
  axiosGet,
  axiosPost,
  axiosDelete,
  axiosPut,
  timeToStamp,
  uploadfile,
}



// WEBPACK FOOTER //
// ./src/assets/js/global_variable.js